import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Empty.module.css';

const EmptyOrdersCard = () => {

    const navigate = useNavigate();

    const handleShop = () => {
      navigate('/marketplace')
    };
  return (
    <>
    <button className={styles.lipaworld_backButton} onClick={handleShop}>
          <svg width="20" height="20" viewBox="0 0 24 24">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
          <span className={styles.backText}>Back to Shop</span>
      </button><div className={styles.emptyOrdersContainer}>
              <div className={styles.emptyOrdersCard}>
                  <div className={styles.cartIconWrapper}>
                      <div className={styles.cartIcon}>
                          <img src='/img/shop/empty.svg' />
                      </div>
                  </div>
                  <h2 className={styles.emptyOrdersTitle}>You haven't placed any orders yet!</h2>
                  <p className={styles.emptyOrdersDescription}>
                      Start exploring our marketplace and send value to your loved ones back home. From shopping to healthcare, there's something for everyone!
                  </p>
                  <button className={styles.startShoppingButton}>Start Shopping</button>
              </div>
          </div>
          </>
  );
};

export default EmptyOrdersCard;